import React, {useEffect, useState} from 'react'
import './StoryContent.css'
import classNames from 'classnames'
import StoryDate from './StoryDate'

type Props = {
  content: storyContent
}

export default function StoryContent(props: Props) {
  const [landscape, setLandscape] = useState(true)
  useEffect(() => {
    const loadImg = (path: string): Promise<HTMLImageElement> => {
      return new Promise((resolve, reject) => {
        const el = new Image()
        el.onload = () => resolve(el)
        el.onerror = e => reject(e)
        el.src = path
      })
    }
    const isLandscape = (path: string): Promise<boolean> => {
      return loadImg(path).then(res => res.height < res.width)
    }
    isLandscape(props.content.image).then(landscape => {
      setLandscape(landscape)
    })
  }, [props.content.image, setLandscape])

  const classes = classNames({ landscape })
  return (
    <li className={classes}>
      <img src={props.content.image} alt="" loading="lazy" />
      <h2>
        { 0 < props?.content?.date?.unix() &&
          <StoryDate date={props.content.date} />
        }
      </h2>
      <p>{props.content.comment}</p>
    </li>
  )
}
